import React from "react";
import { useTranslation } from "react-i18next";
import { bucketTopN } from "./_shared/bucketTopN";

const topOf = (list, labelKey, valueKey) => {
  if (!list?.length) return null;
  return [...list].sort((a, b) => (b[valueKey] || 0) - (a[valueKey] || 0))[0];
};

const ReportInsight = ({ report }) => {
  const { t } = useTranslation();
  if (!report) return null;

  const topShape = topOf(report.DiamondShapeSearches, "Cut", "CNT");
  const topColor = topOf(report.DiamondColorSearches, "Color", "CNT");
  const topCert = topOf(report.DiamondCertificateSearches, "Certificate", "CNT");
  const topPrice = topOf(report.DiamondPrice, "Range", "TOTAL");

  if (!topShape && !topColor && !topCert && !topPrice) return null;

  const highlights = [
    topShape?.Cut,
    topColor && `${topColor.Color}-${t("color")}`,
    topCert?.Certificate,
    topPrice?.Range,
  ]
    .filter(Boolean)
    .join(", ");

  const { othersCount } = bucketTopN(report.DiamondShapeSearches || [], {
    labelKey: "Cut",
    valueKey: "CNT",
    chartLabel: "Shape",
    max: 10,
    othersLabel: t("Others"),
  });

  return (
    <div className="edr-insight">
      💡 <b>{t("Key takeaway")}:</b> {t("Demand skews toward")} {highlights}.
      {othersCount > 0 && (
        <>
          {" "}
          {t("Meanwhile")} {othersCount}{" "}
          {t('long-tail shape search terms are grouped under "Others"')}.
        </>
      )}
    </div>
  );
};

export default ReportInsight;
